import { BasicConstants } from "../basic/constants/BasicConstants";

/**
 *
 */
export class UrlUtil {
    public static FILE_PROTOCOL: string = "file:";
    public static LOCATEST_FLAG: string = "-locatest";
    public static LIVETEST_FLAG: string = "-livetest";
    public static PRECLIENT_FLAG: string = "-preClient";
    public static PRODUCTION_FLAG: string = "goodgamestudios.com";
    public static TEST_SERVER_FLAG: string = BasicConstants.DOMAIN_INTERNAL_DNS;

    public static getCleanReferrer(referrer: string): string {
        return UrlUtil.getProtocol(referrer) + "://" + UrlUtil.getServerName(referrer);
    }

    public static getServerNameWithPort(url: string): string {
        // Find first slash; second is +1, start 1 after.
        let start: number = url.indexOf("/") + 2;
        let length: number = url.indexOf("/", start);
        return length == -1 ? url.substring(start) : url.substring(start, length);
    }

    public static getServerName(url: string): string {
        let sp: string = UrlUtil.getServerNameWithPort(url);

        // If IPv6 is in use, start looking after the square bracket.
        let delim: number = sp.indexOf("]");
        delim = (delim > -1) ? sp.indexOf(":", delim) : sp.indexOf(":");

        if (delim > 0) {
            sp = sp.substring(0, delim);
        }

        return sp;
    }

    public static getProtocol(url: string): string {
        let slash: number = url.indexOf("/");
        let indx: number = url.indexOf(":/");

        if (indx > -1 && indx < slash) {
            return url.substring(0, indx);
        }
        else {
            indx = url.indexOf("::");

            if (indx > -1 && indx < slash) {
                return url.substring(0, indx);
            }
        }

        return "";
    }

    public static isLocal(url: string): boolean {
        let r: boolean = url ? url.indexOf(UrlUtil.FILE_PROTOCOL) != -1 : false;
        return r;
    }

    public static isTestServer(url: string): boolean {
        let r: boolean = url ? url.indexOf(UrlUtil.TEST_SERVER_FLAG) != -1 : false;
        return r;
    }

    public static isLocaTest(url: string): boolean {
        let r: boolean = url ? url.indexOf(UrlUtil.LOCATEST_FLAG) != -1 : false;
        return r;
    }

    public static isLiveTest(url: string): boolean {
        let r: boolean = url ? url.indexOf(UrlUtil.LIVETEST_FLAG) != -1 : false;
        return r;
    }

    public static isPreClient(url: string): boolean {
        let r: boolean = url ? url.indexOf(UrlUtil.PRECLIENT_FLAG) != -1 : false;
        return r;
    }

    public static isProduction(url: string): boolean {
        let r: boolean = url ? url.indexOf(UrlUtil.PRODUCTION_FLAG) != -1 : false;
        return r;
    }
}
